import React from 'react';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import '../BitsStyles/Expertise.css'; // Import the updated CSS file
import explore1 from '../BitsImages/careersgraduate.jpeg';
import explore2 from '../BitsImages/careersexperinced.webp';
import explore3 from '../BitsImages/careers executives.jpeg';

const services = [
  {
    title: 'Students and Graduates',
    description: 'Graduates and Freshers are always welcome to our company.Come and show case your skills in Bellary Info Tech Solutions.',
    image: explore1, 
      
  },
  {
    title: 'Experienced Professionals',
    description: 'Experienced professionals are always to be fore front for a company success.',
    image: explore2, 
      
  },
  {
    title: 'Executives',
    description: 'To run a company executives like your more important.Come and join us.',
    image: explore3,  
       
  }
];

const Explorecareers = () => {
  return (
    <div className='servicesthreeboxes'>
    <br/>
    <br/>
    <br/>
      <center>
        <h1 style={{color:'black'}}>As a graduate or an experienced professional, Looking for an exciting role and plenty of opportunities? You’re in the right place.</h1>
        <p style={{color:'orange'}}>Each of our professions will help you build your learning agility to make sure you have the right skill at the right time in today’s fast-paced market. These professions are key to our strategy to deliver value to our clients – while enabling you to take on the most exciting and innovative business challenges and take advantage of all that our different industries can offer.</p>
      </center>
      <div className="services-container-bits">
        {services.map((service, index) => (
          <Link to={service.link} className="service-box-bits" key={index}>
            <div className="service-image-bits">
              <img src={service.image} alt={service.title} />
            </div>
            <div className="service-text-bits">
              <h2 style={{color:'blue'}}>{service.title}</h2>
              <p style={{color:'blue'}}>{service.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Explorecareers;
